var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5437_8942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5513 0.863736C36.5109 -2.30402 27.3051 3.71852 25 11.7729L33.8216 8.83233L42.7192 11.7729C44.8918 7.25413 44.5425 2.74373 41.5513 0.863736Z",
    fill: "#E33657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.238 8.83233L25.0001 11.7729C22.7077 3.76302 13.5222 -2.3248 8.44878 0.863735C5.45756 2.74373 5.10812 7.25404 7.28079 11.7729L13.238 8.83233Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5891 36.7675L11.7674 35.2973L2.9458 36.7675V42.6486L11.7674 44.1189L20.5891 42.6486L22.0594 39.7081L20.5891 36.7675ZM47.054 36.7675L38.2324 38.2378L29.4107 36.7675L27.9405 30.1513L29.4107 23.5351L38.2324 22.0648L47.054 23.5351V36.7675Z",
    fill: "#FCB83F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5891 36.7675H2.9458V23.5351L11.7674 22.0648L20.5891 23.5351L22.0594 30.1513L20.5891 36.7675Z",
    fill: "#FDD937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0542 42.6486L38.2326 41.1784L29.4109 42.6486L27.9407 46.3243L29.4109 50H47.0542V42.6486Z",
    fill: "#FCB83F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5891 42.6486H2.9458V50H20.5891L22.0594 46.3243L20.5891 42.6486Z",
    fill: "#FDD937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.145 6.74483C36.5957 4.52893 29.0237 6.77874 25 11.7729L33.8216 13.2431L42.7192 11.7729C42.6464 9.59471 41.7948 7.775 40.145 6.74483Z",
    fill: "#AB3057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86884 6.74483C8.21007 7.775 7.35408 9.59461 7.28076 11.7729L16.1784 13.2431L25 11.7729C20.9548 6.77874 13.4371 4.52893 9.86884 6.74483Z",
    fill: "#E33657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0542 36.7675H29.4109L27.9407 39.7081L29.4109 42.6486H47.0542V36.7675Z",
    fill: "#FA9647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9948 20.5945L39.7029 22.0648L29.4109 20.5945L27.9407 16.1837L29.4109 11.7729H49.9948V20.5945Z",
    fill: "#FCB83F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5892 20.5945L10.2973 22.0648L0.00537109 20.5945V11.7729H20.5892L22.0595 16.1837L20.5892 20.5945Z",
    fill: "#FDD937"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9948 20.5945H29.4109L27.9407 22.0648L29.4109 23.5351H49.9948V20.5945Z",
    fill: "#FA9647"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5892 20.5945H0.00537109V23.5351H20.5892L22.0595 22.0648L20.5892 20.5945Z",
    fill: "#FCB83F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9999 50H20.5891V11.7729H24.9999L26.4702 30.8864L24.9999 50Z",
    fill: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4108 50H25V11.7729H29.4108V50Z",
    fill: "#E33657"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5437_8942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBox);
export default __webpack_public_path__ + "static/media/gift-box.341593465049496f86cef94cdb83ef1e.svg";
export { ForwardRef as ReactComponent };